import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font/font.css'
import store from '@/store'
import '@/mixin'
import '@/command/v_dialog'
import VueClipboard from 'vue-clipboard2'
import plugins from '@/utils/plugins' // 复制粘贴功能
import tool from '@/utils/tool.js'
import storeCase from '@/store/storeCase'

VueClipboard.config.autoSetContainer = true

// 记录全部请求（用于流程中停止运行的操作）
Vue.$requestList = []

Vue.use(plugins)
Vue.use(ElementUI, { size: 'small' })
Vue.use(tool) // 工具
Vue.use(VueClipboard)
Vue.use(storeCase)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
